module.exports = __webpack_public_path__ + "img/pr-5.0d08ef0a.png";